import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../components/TableContent';

interface SkeletonMobileProps {}

export const SkeletonMobile: React.FC<SkeletonMobileProps> = () => {
  return (
    <TableContent direction="row">
      <VStack space={Spacing['inline.xxxs']} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <Skeleton
            w="65%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <HStack space={Spacing['inline.nano']}>
            <Skeleton
              w={Spacing['inline.xs']}
              h={Spacing['inline.xs']}
              borderRadius={BoxRadius.circular}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w={Spacing['inline.xs']}
              h={Spacing['inline.xs']}
              borderRadius={BoxRadius.circular}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </HStack>
        <HStack justifyContent="space-between" space={Spacing['inline.nano']}>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="90px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="60px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="60px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
        </HStack>
        <HStack justifyContent="space-between" space={Spacing['inline.nano']}>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="120px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <Skeleton
            w="40px"
            h="40px"
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </VStack>
    </TableContent>
  );
};
